const URLService = (() => {
    /**
     * @param {string} country 
     * @param {string} lang 
     * @param {string} url 
     * @param {string} parameters 
     * 
     * @return {string} 
     */
    const createURL = (country, lang, url, parameters) => {
        const sendMoneyLinkParams = sendMoneyLink.getParam();
        const params = [parameters, sendMoneyLinkParams].filter(String).join('&');

        return `/${country}/${lang}${url}${params ? `?${params}` : ''}`;
    };

    /**
     * @param {string} country 
     * @param {string} lang 
     * @param {string} parameters 
     * 
     * @return {string} 
     */
    const getStartURL = (country, lang, parameters = '') => {
        return createURL(country, lang, '/web/send-money/start', parameters);
    };

    /**
     * @param {string} country 
     * @param {string} lang 
     * @param {string} parameters 
     * 
     * @return {string} 
     */
    const getRegisterVerifyEmailURL = (country, lang, parameters = '') => {
        return createURL(country, lang, '/web/user/register-verify-email', parameters);
    };

    /**
     * @param {string} country 
     * @param {string} lang 
     * @param {string} parameters 
     * 
     * @return {string} 
     */
    const getLoginURL = (country, lang, parameters = '') => {
        return createURL(country, lang, '/web/user/login', parameters);
    };

    /**
     * @param {string} country 
     * @param {string} lang 
     * @param {string} parameters 
     * 
     * @return {string} 
     */
    const getRegisterURL = (country, lang, parameters = '') => {
        return createURL(country, lang, '/web/user/register', parameters);
    };

    /**
     * @param {string} country 
     * @param {string} lang 
     * @param {string} parameters 
     * 
     * @return {string} 
     */
    const getHistoryURL = (country, lang, parameters = '') => {
        return createURL(country, lang, '/web/user/history', parameters);
    };

    /**
     * @param {string} country 
     * @param {string} lang 
     * @param {string} parameters 
     * 
     * @return {string} 
     */
    const getEstimateDetailsURL = (country, lang, parameters = '') => {
        return createURL(country, lang, '/web/send-money/estimate-details', parameters);
    };

    const URLTypes = {
        'start': getStartURL,
        'register-verify-email': getRegisterVerifyEmailURL,
        'login': getLoginURL,
        'register': getRegisterURL,
        'history': getHistoryURL,
        'estimate-details': getEstimateDetailsURL,
    };

    /**
     * @param {string} type 
     * @param {string} country 
     * @param {string} lang 
     * @param {string} parameters 
     * 
     * @return {string}
     */
    const get = (type, country, lang, parameters = '') => {
        const urlType = URLTypes[type];

        if (urlType) {
            return urlType(country, lang, parameters);
        }

        return '';
    }

    return {
        getStartURL,
        getRegisterVerifyEmailURL,
        getLoginURL,
        getRegisterURL,
        getHistoryURL,
        getEstimateDetailsURL,
        get,
    };
})();
